export default __webpack_public_path__ + "static/media/contect-icon.c60b113b.svg";